import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import About from "./pages/About";
import Projects from "./pages/Projects";
import Header from "./Header";
import Footer from "./Footer";
import { Box } from "@chakra-ui/react"; // Import Chakra's Box component
import WorkPage from "./pages/Work";
import EntreOlas from "./pages/EntreOlas";
import Zines from "./pages/Zines";
import People from "./pages/People";
import Moments from "./pages/Moments";
import TheOldAndalusianWest from "./pages/TheOldAndalusianWest";
import Hormiguero from "./pages/Hormiguero";
import Gibraltar from "./pages/Gibraltar";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import TermsPage from "./pages/TermsPage";
import ClientGalleryPage from "./pages/ClientGallery";
import AdminGallery from "./pages/AdminGallery";
import AdminGalleries from "./pages/AdminGalleries";
import AdminCleanup from "./pages/AdminCleanup";
import AdminDashboard from "./pages/AdminDashboard";
import DownloadPage from "./pages/DownloadPage";
import Prints from "./pages/Prints";
import ToolsPage from "./pages/Tools";
import PrintCategory from "./pages/PrintCategory";
import LocaleWrapper from "./components/LocaleWrapper";
import ScrollToTop from "./components/ScrollToTop";

// Component to redirect old gallery URLs to new language-prefixed URLs
const GalleryRedirect = () => {
  const { token } = useParams();
  return <Navigate to={`/en/client/${token}`} replace />;
};

// Retired store/cart URLs now point at the prints page
const PrintsRedirect = () => {
  const { lng } = useParams();
  const language = lng === 'es' ? 'es' : 'en';
  return <Navigate to={`/${language}/prints`} replace />;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Router>
            <ScrollToTop />
            <Header />
            <Box marginTop={["20%", "15%", "12%", "10%"]}> {/* Add top margin equal to the header height */}
            <Routes>
              {/* Redirect root to default language */}
              <Route path="/" element={<Navigate to="/en" replace />} />
              
              {/* Locale-based routes */}
              <Route path="/:lng" element={<LocaleWrapper><WorkPage /></LocaleWrapper>} />
              <Route path="/:lng/prints" element={<LocaleWrapper><Prints /></LocaleWrapper>} />
              <Route path="/:lng/prints/:category" element={<LocaleWrapper><PrintCategory /></LocaleWrapper>} />
              <Route path="/:lng/projects" element={<LocaleWrapper><Projects /></LocaleWrapper>} />
              <Route path="/:lng/projects/entre-olas" element={<LocaleWrapper><EntreOlas /></LocaleWrapper>} />
              <Route path="/:lng/zines" element={<LocaleWrapper><Zines /></LocaleWrapper>} />
              <Route path="/:lng/zines/gibraltar" element={<LocaleWrapper><Gibraltar /></LocaleWrapper>} />
              <Route path="/:lng/zines/the-old-andalusian-west" element={<LocaleWrapper><TheOldAndalusianWest /></LocaleWrapper>} />
              <Route path="/:lng/zines/hormiguero" element={<LocaleWrapper><Hormiguero /></LocaleWrapper>} />
              <Route path="/:lng/people" element={<LocaleWrapper><People /></LocaleWrapper>} />
              <Route path="/:lng/moments" element={<LocaleWrapper><Moments /></LocaleWrapper>} />
              <Route path="/:lng/services" element={<LocaleWrapper><Services /></LocaleWrapper>} />
              <Route path="/:lng/blog" element={<LocaleWrapper><Blog /></LocaleWrapper>} />
              <Route path="/:lng/blog/:slug" element={<LocaleWrapper><BlogPost /></LocaleWrapper>} />
              <Route path="/:lng/terms" element={<LocaleWrapper><TermsPage /></LocaleWrapper>} />
              <Route path="/:lng/about" element={<LocaleWrapper><About /></LocaleWrapper>} />
              <Route path="/:lng/tools" element={<LocaleWrapper><ToolsPage /></LocaleWrapper>} />
              
              {/* Client gallery routes with language support */}
              <Route path="/:lng/client/:token" element={<LocaleWrapper><ClientGalleryPage /></LocaleWrapper>} />
              {/* Backward compatibility: redirect old gallery URLs to English */}
              <Route path="/client/:token" element={<GalleryRedirect />} />
              
              {/* Admin gallery routes */}
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/galleries" element={<AdminGalleries />} />
              <Route path="/admin/gallery" element={<AdminGallery />} />
              <Route path="/admin/gallery/:galleryId" element={<AdminGallery />} />
              <Route path="/admin/cleanup" element={<AdminCleanup />} />
              
              {/* Download page */}
              <Route path="/download/:token" element={<DownloadPage />} />
              
              {/* Retired store/cart routes → prints */}
              <Route path="/:lng/store" element={<PrintsRedirect />} />
              <Route path="/:lng/store/product/:productId" element={<PrintsRedirect />} />
              <Route path="/:lng/cart" element={<PrintsRedirect />} />
              <Route path="/:lng/orders" element={<PrintsRedirect />} />
              <Route path="/:lng/order-confirmation" element={<PrintsRedirect />} />
              <Route path="/store" element={<Navigate to="/en/prints" replace />} />
              <Route path="/store/product/:productId" element={<Navigate to="/en/prints" replace />} />
              <Route path="/cart" element={<Navigate to="/en/prints" replace />} />

              {/* Fallback for old routes without language prefix */}
              <Route path="/prints" element={<Navigate to="/en/prints" replace />} />
              <Route path="/prints/:category" element={<Navigate to="/en/prints/:category" replace />} />
              <Route path="/projects" element={<Navigate to="/en/projects" replace />} />
              <Route path="/services" element={<Navigate to="/en/services" replace />} />
              <Route path="/about" element={<Navigate to="/en/about" replace />} />
              <Route path="/blog" element={<Navigate to="/en/blog" replace />} />
              <Route path="/tools" element={<Navigate to="/en/tools" replace />} />
            </Routes>
          </Box>
          <Footer />
        </Router>
    </div>
    </HelmetProvider>
  );
}

export default App;
